export default __webpack_public_path__ + "static/media/my-resources.4ad09227.png";